import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import 'LIBS/jquery.showhtml.js';
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.VIPFinancingModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.VIPFinancingModal = (function (_super) {
    __extends(VIPFinancingModal, _super);

    function VIPFinancingModal() {
        var modal = VIPFinancingModal.__super__.constructor.call(this);
        this.Close.off();
        this.isCheckout = false;
        this.resubmitConfig = {};
        this.commerceService = HSN.Instance()._getCommerceService();

        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            cancel(modal);
        });
        $(modal.Content).on('click', '#continue', function () {
            $('.confirm-container').removeClass('input-validation-error');
            if (!$('#confirmation', modal.Content).is(':checked')) {
                $('.confirm-container').addClass('input-validation-error');
                return false;
            }
            HSN.LoaderSetWait();

            var config = modal.resubmitConfig;
            modal.commerceService.ProcessOrder({ debitAuthorized: config.debitAuthorized, debitAuthorizationRequired: config.debitAuthorizationRequired, sessionIdentity: config.sessionIdentity, isDeferredContinue: true }, {
                callback: function (data) {
                    if (data.success) {
                        if (data.isBagGiveawayWinner) {
                            HSN.RemoveWait();
                            var winnerModal = HSN.Instance().GetGenericConfirmModal();
                            winnerModal.SetInputData({});
                            winnerModal.SetOkCallback(function () {
                                window.location = data.NextUrl;
                            });
                            winnerModal.SetCloseClickCallback(function () {
                                window.location = data.NextUrl;
                            });
                            winnerModal.Show('/checkout/bag-giveaway-winner');
                        }
                        else {
                            window.location = data.NextUrl;
                        }
                    }
                    else {
                        if (data.RequiresCardVerification) {
                            HSN.RemoveWait();
                            HSN.Instance().GetCardVerificationModal().Show(config.cvvUrl);
                        }
                        else if (data.NextUrl) {
                            window.location = data.NextUrl;
                        }
                        else {
                            HSN.CheckoutHandleError(modal.Content, data, 'Unfortunately there was a problem submitting your order, please try again.');
                        }
                    }
                }
            });

            modal.Hide();
            return false;
        });

        $(modal.Content).on('click', '#cancel', function () {
            cancel(modal);
            return false;
        });

        $(modal.Content).on('click', '#print', function () {
            HSN.PrintElement(document.getElementById('vip-financing-modal'));
            window.print();
            return false;
        });
    }

    function cancel(modal) {
        if (modal.isCheckout) {
            modal.Content.remove();
            modal.AddLoadingSpinner();
            modal.commerceService.RemoveVipFinancing({}, {
                callback: function () {
                    window.location.reload(true);
                }
            });
        }
        else {
            modal.Hide();
        }
    }

    /**
    * HSN.VIPFinancingModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    VIPFinancingModal.prototype._show = function (id, isCheckout, resubmitConfig) {
        var scope = this;
        scope.isCheckout = isCheckout;
        scope.resubmitConfig = resubmitConfig || {};
        scope.AddLoadingSpinner();
        var url = '/vipfinancing/get/' + id;
        if (isCheckout) {
            url = url + '?isCheckout=true';
        }
        $.ajax(
            url,
            {
                context: this,
                dataType: 'html',
                data: {},
                success: function (data, status, xhr) {
                    scope.RemoveLoadingSpinner();
                    this.Content.showHtml (
                        data,
                        0,
                        function () {
                            scope.Center();
                            scope.Content.animate({ opacity: 1 });
                        },
                        function () {
                        }
                    );

                },
                error: function (xhr, status, error) {
                    alert('Unfortunately there was an error attempting to load the content, please try again.');
                    $('#modal-mask').remove();
                }
            }
        );
    };

    return VIPFinancingModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/VIPFinancingModal.js